/*------------------------------------*\
    Waypoints Sticky
\*------------------------------------*/

module.exports = function(){

    $(function(){

        var $windowWidth = $(window).width();


        if ($('.js-header').length) {


            // Header
            var stickyHeader = new Waypoint.Sticky({
                element: $('.js-header'),
                handler: function() {
                },
                stuckClass: 'is-sticky',
                direction: 'down',
                offset: -50,
                wrapper: false
            });


        }




        // Notification
        var $notification = $('.js-notification');
        if($notification.length > 0) {
            var stickyNotification = new Waypoint.Sticky({
                element: $notification,
                handler: function() {
                },
                stuckClass: 'is-sticky',
                direction: 'down',
                offset: -50,
                wrapper: false
            });

        }



        // Shop toolbar

        var $toolbar = $('.js-toolbar');
        if($toolbar.length > 0) {
            var stickyToolbar = new Waypoint.Sticky({
                element: $toolbar,
                stuckClass: 'is-sticky',
                offset: $toolbar.outerHeight()
            });
        }




        // Steps

        var $steps = $('.js-steps');
        if($steps.length > 0 && $windowWidth >= 900) {
            var stepsWaypoint = new Waypoint({
                element: $('.js-product-info'),
                handler: function(direction) {
                    if(direction == 'down') {
                        $steps.css({'position': 'absolute'});
                    } else if(direction == 'up') {
                        $steps.css({'position': 'fixed'});
                    }
                },
                offset: 'bottom-in-view'
            });
        }





        // Cart dropdown total

        var $total = $('.js-total');
        if($total.length > 0) {
            var totalWaypoint = new Waypoint({
                element: $('.js-dropdown'),
                handler: function(direction) {
                    if(direction == 'down') {
                        $total.css({'position': 'absolute'});
                    } else if(direction == 'up') {
                        $total.css({'position': 'fixed'});
                    }
                },
                offset: 'bottom-in-view'
            });
        }



        // Get Educated menu

        var stickyEducated = function(){

            var $windowWidth = $(window).width();
            var $menu = $('.js-get-educated-menu');


            if (window.windowGetEducatedStickyMenu) {
                window.windowGetEducatedStickyMenu.destroy();
            }

            if(($menu.length > 0) && ($windowWidth >= 500)) {
                window.windowGetEducatedStickyMenu = new Waypoint.Sticky({
                    element: $menu,
                    stuckClass: 'is-sticky',
                    direction: 'down',
                    offset: -50,
                    wrapper: false,
                    handler: function() {

                    },
                });

            }


        };

        stickyEducated();


        $(window).on('resize', function(event) {
            stickyEducated();
        });
    });


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/sticky.js